export default __webpack_public_path__ + "static/media/le_croise16.cdf0b928.jpg";